import { loc } from "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import Model from "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import fn from "../../util/CookieUtil.js";
import Enums from "../../util/Enums.js";
import BaseLoginModel from "./BaseLoginModel.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var PrimaryAuthModel = BaseLoginModel.extend({
  props: function() {
    const cookieUsername = fn.getCookieUsername();
    const properties = this.getUsernameAndRemember(cookieUsername);
    const props = {
      username: {
        type: "string",
        validate: function(value) {
          if (oktaUnderscore.isEmpty(value)) {
            return loc("error.username.required", "login");
          }
        },
        value: properties.username
      },
      lastUsername: ["string", false, cookieUsername],
      context: ["object", false],
      remember: ["boolean", true, properties.remember],
      multiOptionalFactorEnroll: ["boolean", true]
    };
    if (!(this.settings && this.settings.get("features.passwordlessAuth"))) {
      props.password = {
        type: "string",
        validate: function(value) {
          if (oktaUnderscore.isEmpty(value)) {
            return loc("error.password.required", "login");
          }
        }
      };
    }
    return props;
  },
  getUsernameAndRemember: function(cookieUsername) {
    const settingsUsername = this.settings && this.settings.get("username");
    const rememberMeEnabled = this.settings && this.settings.get("features.rememberMe");
    let remember = false;
    let username;
    if (settingsUsername) {
      username = settingsUsername;
      remember = rememberMeEnabled && username === cookieUsername;
    } else if (rememberMeEnabled && cookieUsername) {
      username = cookieUsername;
      remember = true;
    }
    return {
      username,
      remember
    };
  },
  constructor: function(options) {
    this.settings = options && options.settings;
    this.appState = options && options.appState;
    Model.apply(this, arguments);
    this.listenTo(this, "change:username", function(model, username) {
      this.set({
        remember: username === this.get("lastUsername")
      });
    });
  },
  parse: function(options) {
    return oktaUnderscore.omit(options, ["settings", "appState"]);
  },
  save: function() {
    const username = this.settings.transformUsername(this.get("username"), Enums.PRIMARY_AUTH);
    const remember = this.get("remember");
    const lastUsername = this.get("lastUsername");
    this.setUsernameCookie(username, remember, lastUsername);
    this.trigger("save");
    this.appState.trigger("loading", true);
    const signInArgs = this.getSignInArgs(username);
    let primaryAuthPromise;
    if (this.appState.get("isUnauthenticated")) {
      const authClient = this.appState.settings.getAuthClient();
      if (this.appState.get("isIdxStateToken")) {
        primaryAuthPromise = this.doTransaction(function(transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.login);
        });
      } else {
        primaryAuthPromise = this.doTransaction(function(transaction) {
          return this.doPrimaryAuth(authClient, signInArgs, transaction.authenticate);
        }, true);
      }
    } else {
      primaryAuthPromise = this.startTransaction(function(authClient) {
        return this.doPrimaryAuth(authClient, signInArgs, oktaUnderscore.bind(authClient.signInWithCredentials, authClient));
      });
    }
    return primaryAuthPromise.catch(() => {
      this.appState.trigger("removeLoading");
      fn.removeUsernameCookie();
    }).finally(() => {
      this.appState.trigger("loading", false);
    });
  },
  getSignInArgs: function(username) {
    const multiOptionalFactorEnroll = this.get("multiOptionalFactorEnroll");
    const signInArgs = {};
    if (!this.settings.get("features.passwordlessAuth")) {
      signInArgs.password = this.get("password");
    }
    if (this.appState.get("isIdxStateToken")) {
      signInArgs.identifier = username;
    } else {
      signInArgs.username = username;
      signInArgs.options = {
        warnBeforePasswordExpired: true,
        multiOptionalFactorEnroll
      };
    }
    return signInArgs;
  },
  setUsernameCookie: function(username, remember, lastUsername) {
    if (this.settings.get("features.rememberMe")) {
      if (!remember && lastUsername === username) {
        fn.removeUsernameCookie();
      } else if (remember) {
        fn.setUsernameCookie(username);
      }
    }
  },
  doPrimaryAuth: function(authClient, signInArgs, func) {
    const deviceFingerprintEnabled = this.settings.get("features.deviceFingerprinting");
    const typingPatternEnabled = this.settings.get("features.trackTypingPattern");
    if (deviceFingerprintEnabled && this.appState.get("deviceFingerprint")) {
      authClient.http.setRequestHeader("X-Device-Fingerprint", this.appState.get("deviceFingerprint"));
    }
    if (typingPatternEnabled && this.appState.get("typingPattern")) {
      authClient.http.setRequestHeader("X-Typing-Pattern", this.appState.get("typingPattern"));
    }
    const self = this;
    return func(signInArgs).finally(function() {
      if (deviceFingerprintEnabled) {
        authClient.http.setRequestHeader("X-Device-Fingerprint", void 0);
        self.appState.unset("deviceFingerprint");
      }
      if (typingPatternEnabled) {
        authClient.http.setRequestHeader("X-Typing-Pattern", void 0);
        self.appState.unset("typingPattern");
      }
    });
  }
});
export { PrimaryAuthModel as default };
